<template>
  <v-navigation-drawer
    permanent
    floating
    app
    :mini-variant="sidebarSmall"
    mini-variant-width="80"
    width="264"
    class="app-sidebar"
  >
    <template #append>
      <v-btn
        class="text-body-2 mx-auto"
        color="primary"
        text
        block
        @click="sidebarSmall = !sidebarSmall"
      >
        <span
          v-if="!sidebarSmall"
          class="mr-2"
        >
          Zwiń menu
        </span>
        <v-icon color="primary">
          mdi-chevron-{{ sidebarSmall ? 'right' : 'left' }}
        </v-icon>
      </v-btn>
    </template>

    <router-link :to="{ name: 'projects-index' }">
      <v-img
        :class="{ 'ml-2' : !sidebarSmall }"
        :src="sidebarSmall
          ? require(`@/assets/img/LOGO_NBP_SMALL.png`)
          : require(`@/assets/img/LOGO_NBP.png`)"
        height="56"
        position="left"
        contain
      />
    </router-link>

    <v-list
      class="mt-16 pa-0"
      dense
      nav
    >
      <div
        v-for="nav in navs"
        :key="nav.title"
      >
        <template v-if="checkUserPermissions(nav.permission)">
          <v-list-group
            v-if="nav.children"
            v-model="nav.active"
            color="#848A89"
            append-icon="mdi-menu-down"
          >
            <template #activator>
              <div
                class="relative"
                :class="{'mr-4' : !sidebarSmall}"
              >
                <v-img
                  :class="[
                    'nav-icon',
                    nav.active && 'nav-icon--active'
                  ]"
                  :src="`/icons/${nav.icon}on.svg`"
                />
                <v-img :src="`/icons/${nav.icon}off.svg`" />
              </div>
              <v-list-item-title
                v-if="!sidebarSmall"
                class="text-body-2 text-wrap lh-21"
                :class="nav.active ? 'primary--text font-weight-medium' : 'light-grey--text'"
              >
                {{ nav.label }}
              </v-list-item-title>
            </template>
            <template v-for="child in nav.children.routes">
              <router-link
                v-if="checkUserPermissions(child.permission)"
                :key="child.label"
                :to="{name: child.routeName}"
              >
                <v-list-item class="pl-6 mb-1">
                  <div
                    class="relative"
                    :class="{'mr-4' : !sidebarSmall}"
                  >
                    <v-img
                      :class="[
                        'nav-icon',
                        child.active && 'nav-icon--active'
                      ]"
                      :src="`/icons/${child.icon || nav.children.icon}on.svg`"
                    />
                    <v-img :src="`/icons/${child.icon || nav.children.icon}off.svg`" />
                  </div>

                  <v-list-item-title
                    v-if="!sidebarSmall"
                    class="text-body-2 text-wrap lh-21"
                    :class="child.active ? 'primary--text font-weight-medium' : 'light-grey--text'"
                  >
                    {{ child.label }}
                  </v-list-item-title>
                </v-list-item>
              </router-link>
            </template>
          </v-list-group>

          <router-link
            v-else
            :to="{name: nav.routeName}"
          >
            <v-list-item>
              <div
                class="relative"
                :class="{'mr-4' : !sidebarSmall}"
                style="width:20px; height:20px"
              >
                <v-img
                  :class="[
                    'nav-icon',
                    nav.active && 'nav-icon--active'
                  ]"
                  :src="`/icons/${nav.icon}on.svg`"
                />
                <v-img :src="`/icons/${nav.icon}off.svg`" />
              </div>

              <v-list-item-content>
                <v-list-item-title
                  class="text-body-2 text-wrap  lh-21"
                  :class="nav.active ? 'primary--text font-weight-medium' : 'light-grey--text'"
                >
                  {{ nav.label }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
        </template>
      </div>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';
import navs from '@/helpers/navs';

export default {
  data() {
    return {
      navs,
      sidebarSmall: false,
    };
  },

  computed: {
    routeName() {
      return this.$route.name;
    },
    ...mapGetters('auth', [
      'checkUserPermissions',
    ]),
  },

  watch: {
    routeName: {
      immediate: true,
      handler() {
        let name = '';
        if (this.routeName.indexOf('project') === 0) {
          name = 'projects-index';
        } else if (this.routeName.indexOf('archive-project') === 0) {
          name = 'archive-projects';
        } else {
           name = this.routeName;
        }
        this.setNavActive(name);
      },
    },
  },

  methods: {
    setNavActive(routeName) {
      this.navs = this.navs.map((nav) => (
        nav.children ? {
          ...nav,
          active: !!nav.children.routes
            .reduce((acc, obj) => (obj.routeName === routeName) + acc, 0),
          children: {
            ...nav.children,
            routes: nav.children.routes.map((route) => ({
              ...route,
              active: route.routeName === routeName,
            })),
          },
        } : {
          ...nav,
          active: nav.routeName === routeName,
        }));
    },

    setIconState(value, active) {
      return `/icons/${value}${active ? 'on' : 'off'}.svg`;
    },
  },
};
</script>

<style lang="scss" scoped>
.app-sidebar {
  box-shadow: 0px 0 6px 0px $box-shadow-color;
  padding: 24px 16px;
}

.nav-icon {
  position:absolute;
  z-index:1;
  opacity:0;
  transition: opacity 0.2s ease;
  &--active {
    opacity:1;
  }
}
</style>
